import React, { useCallback, useRef } from 'react';
import { Form } from '@unform/web';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import getValidationErros from '~/utils/getValidationsErrors';

import { Container } from './styles';
import Input from '~/components/Input';

import logo from '~/assets/logos/logo.svg';
import signinBackground from '~/assets/banners/signin-background.svg';
import api from '~/services/api';

interface IParams {
  token: string;
}

const ChangePassword: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const params = useParams<IParams>();
  const history = useHistory();

  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          password: Yup.string().required('A senha é obrigatória'),
          confirmPassword: Yup.string().oneOf(
            [Yup.ref('password'), null],
            'As senhas devem ser iguais'
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post(`suppliers/sessions/new-password/${params.token}`, {
          password: data.password,
        });

        history.push(`${process.env.PUBLIC_URL}/fornecedor/login`);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          console.log('');
          console.log('ChangePassword');
          console.log(error);
          Swal.fire('Oops...', 'Ocorreu um erro tente novamente, por favor');
        }
      }
    },
    [history, params.token]
  );

  return (
    <Container>
      <div className="container py-5">
        <div className="row justify-content-between">
          <div className="col-lg-5 pt-5">
            <Link
              to={`${process.env.PUBLIC_URL}/fornecedor/login`}
              className="d-flex d-lg-none align-items-center logo mb-5"
            >
              <img src={logo} alt="logo" className="me-2" />
              <span className="text-secondary text-start d-block small mb-0 fw-bold">
                INSTITUTO <br />
                <span className="d-block h4 mb-0 fw-bold mt-n1">BARUERI</span>
              </span>
            </Link>
            <div className="w-100">
              <h1 className="text-secondary">Recuperar senha</h1>
              <p className="h5 fw-light text-secondary">
                Informe sua nova senha abaixo
              </p>
            </div>
            <Form ref={formRef} onSubmit={handleSubmit} className="mt-5">
              <label className="d-block w-100 mb-3">
                <span className="text-secondary fw-medium mb-2 d-block">
                  Senha
                </span>
                <Input
                  type="password"
                  name="password"
                  placeholder="Insira sua nova senha"
                />
              </label>
              <label className="d-block w-100 mb-3">
                <span className="text-secondary fw-medium mb-2 d-block">
                  Confirmar Senha
                </span>
                <Input
                  type="password"
                  name="confirmPassword"
                  placeholder="Repita sua nova senha"
                />
              </label>
              <button
                type="submit"
                className="btn btn-primary rounded-pill w-100 py-2 mt-5"
              >
                Continuar
              </button>
            </Form>
          </div>
          <div className="col-lg-5 d-none d-lg-block">
            <img src={signinBackground} alt="" className="w-100" />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ChangePassword;
